import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { motion } from "framer-motion";

// Images
import BannerCardapio from '../images/Banner__cardápio.jpg';
import BannerCombo from '../images/Banner_combo.jpg';
import SalgadoImg from '../images/Salgado_frito.jpg';
import PastelImg from '../images/Pastel_Frito.jpg';
import ChurrosImg from '../images/Churros_frito.jpg';
import BrigadeiroImg from '../images/Brigadeiro.jpg';
import EsfirraImg from '../images/Esfirra_congelada.jpg';
import NhoqueImg from '../images/Nhoque_Congelado.jpg';
import PaoQueijoImg from '../images/Pão_queijo.jpg';
import { useNavigate } from 'react-router-dom';


const MenuSection = ({ title, description, flavors, pricing, image, reverse }) => {
    const navigate = useNavigate();

    const handleNavigation = (target) => {
        if (target.startsWith('#')) {
            if (window.location.pathname === '/') {
                const element = document.getElementById(target.substring(1));
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            } else {
                navigate('/');
                setTimeout(() => {
                    const element = document.getElementById(target.substring(1));
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 400); 
            }
        } else {
            navigate(target);
        }
    };

    return (
        <div className={`flex flex-col md:flex-row gap-8 items-center py-12 ${reverse ? 'md:flex-row-reverse' : ''}`}>
             <div className="flex-1 space-y-6">
                <h2 className="text-3xl md:text-4xl font-black text-[#E63312] uppercase tracking-wide">{title}</h2>
                {description && <p className="text-gray-700 text-lg leading-relaxed font-medium">{description}</p>}
                
                {flavors && (
                    <div className="bg-[#FFF8E3] p-6 rounded-xl border border-[#E63312]/20">
                        <h4 className="font-bold text-[#E63312] mb-4 uppercase">Sabores</h4>
                        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                            {flavors.map((flavor, idx) => (
                                <li key={idx} className="flex items-center gap-2 text-gray-800 font-semibold">
                                    <span className="w-1.5 h-1.5 bg-[#E63312] rounded-full"></span>
                                    {flavor}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {pricing && (
                    <div className="bg-white p-6 rounded-xl shadow-lg border-l-4 border-[#E63312]">
                         <h4 className="font-bold text-[#E63312] mb-4 uppercase">Valores</h4>
                         <div className="grid grid-cols-2 gap-4">
                            {pricing.map((item, idx) => (
                                <div key={idx} className="flex justify-between items-center border-b border-gray-100 pb-2 last:border-0">
                                    <span className="font-medium text-gray-600">{item.qty}</span>
                                    <span className="font-black text-[#E63312] text-lg">{item.price}</span>
                                </div>
                            ))}
                         </div>
                    </div>
                )}
                
                <Button 
                    onClick={() => handleNavigation('#lojas')}
                    className="w-full md:w-auto bg-[#E63312] hover:bg-[#FFC300] text-white hover:text-[#E63312] font-black uppercase tracking-wider h-12 px-8 rounded-full shadow-lg transition-all"
                >
                    Fazer Pedido
                </Button>
             </div>
             
             <div className="flex-1 w-full">
                <div className="relative aspect-square md:aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl group">
                    <img 
                        src={image} 
                        alt={title} 
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                     <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                </div>
             </div>
        </div>
    );
};

const FrozenSection = ({ title, description, flavors, pricing, image }) => {
     return (
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col h-full border border-gray-100 hover:shadow-2xl transition-all duration-300">
            <div className="h-64 overflow-hidden relative">
                 <img 
                    src={image} 
                    alt={title} 
                    className="w-full h-full object-cover transition-transform duration-700 hover:scale-110"
                />
            </div>
            <div className="p-8 flex flex-col flex-grow">
                <h3 className="text-2xl font-black text-[#E63312] uppercase mb-4 leading-tight">{title}</h3>
                {description && <p className="text-gray-600 mb-6 text-sm">{description}</p>}
                
                <div className="flex-grow">
                     {flavors && (
                        <ul className="mb-6 space-y-2">
                            {flavors.map((flavor, idx) => (
                                <li key={idx} className="flex items-center gap-2 text-gray-800 font-semibold text-sm">
                                    <span className="w-1.5 h-1.5 bg-[#FFC300] rounded-full"></span>
                                    {flavor}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                <div className="mt-auto pt-6 border-t border-gray-100 flex items-center justify-between">
                     <span className="font-bold text-gray-500">{pricing.qty}</span>
                     <span className="font-black text-[#E63312] text-2xl">{pricing.price}</span>
                </div>
            </div>
        </div>
     )
}

const Menu = () => {
  // --- CORREÇÃO AQUI: Adicionamos o hook e a função no componente Pai (Menu) ---
  const navigate = useNavigate();

  const handleNavigation = (target) => {
      if (target.startsWith('#')) {
          if (window.location.pathname === '/') {
              const element = document.getElementById(target.substring(1));
              if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
              }
          } else {
              navigate('/');
              setTimeout(() => {
                  const element = document.getElementById(target.substring(1));
                  if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                  }
              }, 400); 
          }
      } else {
          navigate(target);
      }
  };
  // -----------------------------------------------------------------------------

  return (
    <div className="min-h-screen bg-white font-sans text-gray-900 pt-[164px]">
      <Header />
      
      <main>
         {/* Top Banner - Quantity Guide */}
         <div className="w-full">
            <img src={BannerCardapio} alt="Guia de Quantidades" className="w-full h-auto object-cover" />
         </div>

         <div className="container mx-auto px-4 py-16 space-y-20">
            
            {/* Salgado Frito */}
            <MenuSection 
                title="Salgado Frito"
                description="Nossos salgados são muito crocantes por fora e com recheio que derrete na boca. São 10 deliciosos sabores para deixar seus momentos ainda mais especiais."
                flavors={[
                    "Coxinha de frango", "Bolinha de queijo", "Kibe", 
                    "Presunto com queijo", "Calabresa com queijo", "Carne", 
                    "Croquete de carne", "Salsicha empanada", "Requeijão", "Milho com queijo"
                ]}
                pricing={[
                    { qty: "25 unidades", price: "R$ 20,00" },
                    { qty: "50 unidades", price: "R$ 30,00" },
                    { qty: "100 unidades", price: "R$ 60,00" },
                    { qty: "150 unidades", price: "R$ 90,00" },
                    { qty: "200 unidades", price: "R$ 120,00" }
                ]}
                image={SalgadoImg}
            />

            {/* Pastel Frito */}
            <MenuSection 
                title="Pastel Frito"
                description="Pequenos no tamanho, gigantes no sabor! Nossos pastéis aperitivos vêm com recheio generoso de carne ou queijo, temperados com aquele toque especial."
                flavors={["Carne", "Queijo"]}
                pricing={[
                    { qty: "25 unidades", price: "R$ 20,00" },
                    { qty: "50 unidades", price: "R$ 30,00" },
                    { qty: "100 unidades", price: "R$ 60,00" },
                    { qty: "150 unidades", price: "R$ 90,00" },
                    { qty: "200 unidades", price: "R$ 120,00" }
                ]}
                image={PastelImg}
                reverse={true}
            />

            {/* Churros Frito */}
            <MenuSection 
                title="Churros Frito"
                description="A tradicional receita do churros agora na versão de doce de leite ou chocolate. Crocante por fora e com muito recheio por dentro."
                flavors={["Doce de leite", "Chocolate"]}
                pricing={[
                    { qty: "25 unidades", price: "R$ 20,00" },
                    { qty: "50 unidades", price: "R$ 30,00" },
                    { qty: "100 unidades", price: "R$ 60,00" },
                    { qty: "150 unidades", price: "R$ 90,00" },
                    { qty: "200 unidades", price: "R$ 120,00" }
                ]}
                image={ChurrosImg}
            />

             {/* Brigadeiro */}
             <MenuSection 
                title="Brigadeiro"
                description="Nosso brigadeiro é aquele clássico que nunca falha: cremoso, intenso e com o sabor marcante do chocolate de verdade."
                pricing={[
                    { qty: "25 unidades (1 bandeja)", price: "R$ 25,00" },
                    { qty: "50 unidades (2 bandejas)", price: "R$ 50,00" },
                    { qty: "75 unidades (3 bandejas)", price: "R$ 75,00" },
                    { qty: "100 unidades (4 bandejas)", price: "R$ 85,00" }
                ]}
                image={BrigadeiroImg}
                reverse={true}
            />
         </div>

         {/* Combo Banner */}
         <div className="w-full relative py-20 bg-gray-900 overflow-hidden group cursor-pointer">
            <div className="absolute inset-0 opacity-40 group-hover:opacity-30 transition-opacity">
                <img src={BannerCombo} alt="Combo" className="w-full h-full object-cover" />
            </div>
            <div className="container mx-auto px-4 relative z-10 text-center text-white">
                <h2 className="text-4xl md:text-6xl font-black uppercase mb-8 drop-shadow-xl">Pede o Combo que é Sucesso!</h2>
                <div className="flex flex-col md:flex-row justify-center gap-8 mb-12">
                    <div className="bg-[#E63312] p-6 rounded-xl shadow-2xl transform hover:scale-105 transition-transform">
                        <p className="font-bold text-lg mb-2 uppercase">Qualquer pedido</p>
                        <p className="text-5xl font-black text-[#FFC300]">+ R$ 5,00</p>
                        <p className="font-medium mt-2">Leva 1 Refrigerante Vannucci (2L)</p>
                    </div>
                </div>
                {/* AGORA O handleNavigation EXISTE NESSE ESCOPO */}
                <Button 
                    onClick={() => handleNavigation('#lojas')}
                    className="bg-[#FFC300] text-[#E63312] hover:bg-white font-black px-12 py-8 text-xl rounded-full uppercase tracking-widest"
                >
                    Pedir Agora
                </Button>
            </div>
         </div>

         {/* Frozen Section */}
         <div className="bg-[#FFF8E3] py-20">
            <div className="container mx-auto px-4">
                 <div className="text-center mb-16">
                    <h2 className="text-4xl font-black uppercase text-[#E63312] tracking-wide">Linha Congelados</h2>
                    <p className="text-gray-600 mt-4 max-w-2xl mx-auto">Leve o sabor d'O Famoso para sua casa e prepare quando quiser.</p>
                 </div>

                 <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <FrozenSection 
                        title="Esfirra Assada"
                        description="Nossas esfirras são muito práticas e deliciosas. Com a receita de família, basta somente aquecer no microondas por 2 minutos."
                        flavors={["Carne", "Frango com requeijão"]}
                        pricing={{ qty: "1kg", price: "R$ 25,00" }}
                        image={EsfirraImg}
                    />
                     <FrozenSection 
                        title="Nhoque Recheado"
                        description="Deliciosa massa de mandioca, com muito recheio! Basta aquecer junto com molho. (Molho não incluso)."
                        flavors={["Presunto com queijo", "Quatro queijos"]}
                        pricing={{ qty: "500g", price: "R$ 8,50" }}
                        image={NhoqueImg}
                    />
                     <FrozenSection 
                        title="Pão de Queijo"
                        description="O tradicional pão de queijo com a qualidade e sabor d’O Famoso. Prático e delicioso para o lanche!"
                        pricing={{ qty: "500g", price: "R$ 8,50" }}
                        image={PaoQueijoImg}
                    />
                 </div>
            </div>
         </div>

      </main>

      <Footer />
    </div>
  );
};

export default Menu;